import { render, staticRenderFns } from "./ISOCertified.vue?vue&type=template&id=338092b6&"
import script from "./ISOCertified.vue?vue&type=script&lang=js&"
export * from "./ISOCertified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports